import { Accordion, AccordionSummary, Box, Card, CardContent, Divider, Stack, styled, TabPanel } from "~/common/mui";

export const StickyCardContainer = styled(Card, {
  shouldForwardProp: (prop) => prop !== "open",
})<{ open?: boolean }>(({ open }) => ({
  overflow: "visible",
  paddingBottom: open ? "16px" : "0px",
}));

export const OrderCardAccordion = styled(Accordion)(() => ({
  "&:after": {
    display: "none !important",
  },
  "&:before": {
    display: "none !important",
  },
}));

export const OrderCardAccordionSummary = styled(AccordionSummary)(() => ({
  flexDirection: "row-reverse",
  gap: "8px",
  padding: "8px",
  ".MuiAccordionSummary-content": {
    margin: "0px !important",
  },
}));

export const OrderLineHeader = styled(Stack)(({ theme }) => ({
  padding: "16px",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  backgroundColor: theme.palette.surfaceContainer.low,
  height: "60px",
}));

export const OrderLineSummaryContainer = styled(Stack)(({ theme }) => ({
  gap: "16px",
  padding: "16px 24px",
  display: "grid",
  gridTemplateColumns: "1fr 40px",
  backgroundColor: theme.palette.surfaceContainer.low,
}));

export const OrderLineSummary = styled("div")(({ theme: _theme }) => ({
  display: "grid",
  columnGap: "16px",
  rowGap: "16px",
  gridTemplateColumns: "repeat(5, 1fr)",
}));

export const OrderLineServiceCase = styled(Accordion)(({ theme }) => ({
  overflow: "hidden",
  borderRadius: 0,
  backgroundColor: theme.palette.surfaceContainer.low,

  ["&:before"]: {
    display: "none !important",
  },
  ["&:after"]: {
    display: "none !important",
  },
}));

export const OrderSubLineListContainer = styled(Stack)(({ theme }) => ({
  padding: "16px",
  backgroundColor: theme.palette.surfaceContainer.low,
}));

export const OrderSubLineGrid = styled(CardContent)(({ theme }) => ({
  borderLeft: `2px solid ${theme.palette.info.main}`,
  padding: "16px",
  paddingLeft: "8px",
  display: "grid",
  columnGap: "16px",
  rowGap: "16px",
  gridTemplateColumns: "repeat(5, 1fr) 40px",
}));

export const OrderSubLineListDivider = styled(Divider)(({ theme }) => ({
  backgroundColor: theme.palette.surfaceContainer.low,
}));

export const NoServiceCaseContainer = styled(Stack)({
  padding: "21px 110px 0 110px",
  justifyContent: "center",
  alignItems: "center",
  alignSelf: "stretch",
  gap: "8px",
});

export const NoServiceCaseImageContainer = styled("div")({
  width: "512px",
  padding: "7.564px 122.045px 5.29px 122.182px",
  justifyContent: "center",
  alignItems: "center",
});

export const NoServiceCaseImage = styled("img")({
  width: "267px",
  height: "150px",
  objectFit: "cover",
});

export const DeliveryHeader = styled(CardContent)(({ theme }) => ({
  borderTopLeftRadius: "8px",
  borderTopRightRadius: "8px",
  padding: "16px",
  display: "grid",
  columnGap: "16px",
  rowGap: "16px",
  gridTemplateColumns: "repeat(5, 1fr)",
  backgroundColor: theme.palette.surfaceContainer.low,
}));

export const PackageCard = styled(CardContent)(({ theme }) => ({
  padding: "16px",
  display: "grid",
  columnGap: "16px",
  rowGap: "16px",
  gridTemplateColumns: "repeat(5, 1fr)",
  backgroundColor: theme.palette.surfaceContainer.low,
  [" &.MuiCardContent-root:last-of-type"]: {
    paddingBottom: "16px",
  },
}));

export const StyledTabPanel = styled(TabPanel)(({ theme: _theme }) => ({
  "&.MuiTabPanel-root": {
    padding: 0,
  },
}));

export const ShipmentContainer = styled(Box)(({ theme: _theme }) => ({
  "&:last-of-type .MuiCardContent-root": {
    borderBottomLeftRadius: "12px",
    borderBottomRightRadius: "12px",
  },
}));

export const QuoteLineSummaryContainer = styled(Stack)(({ theme }) => ({
  padding: "16px",
  gap: "16px",
  backgroundColor: theme.palette.surfaceContainer.low,
}));

export const QuoteLineSummary = styled(Box)(({ theme: _theme }) => ({
  paddingLeft: "16px",
  display: "grid",
  columnGap: "16px",
  rowGap: "16px",
  gridTemplateColumns: "repeat(5, 1fr)",
}));

export const QuoteHeaderSummaryContainer = styled(Stack)(({ theme }) => ({
  padding: "16px 0",
  gap: "16px",
  backgroundColor: theme.palette.surfaceContainer.low,
}));

export const QuoteAlternateLineItem = styled("div", {
  shouldForwardProp: (prop) => prop !== "hideLeftBorder",
})<{ hideLeftBorder?: boolean }>(({ theme, hideLeftBorder = false }) => ({
  paddingLeft: "16px",
  display: "grid",
  gap: "16px",
  gridTemplateColumns: "repeat(5, 1fr)",
  borderLeft: hideLeftBorder ? 0 : `2px solid ${theme.palette.info.main}`,
}));

export const BorderLeftWrapper = styled(Stack, {
  shouldForwardProp: (prop) => prop !== "variant",
})<{ variant?: "main" | "alternative" }>(({ theme, variant = "main" }) => ({
  marginLeft: "16px",
  gap: "16px",
  borderLeft: `2px solid ${variant == "main" ? theme.palette.primary.main : theme.palette.info.main}`,
}));

export const OverView = styled(Stack)(({ theme }) => ({
  borderRadius: "0 12px 12px 0",
  background: `${theme.palette.surface.main}`,
  width: "387px",
  padding: "16px",
  alignItems: "flex-start",
  flexDirection: "initial",
  gap: "32px",
  flexShrink: "0",
  "& > div": {
    width: "100%",
  },
}));

export const ODetailsSummary = styled(Stack)(({ theme }) => ({
  borderRadius: "12px",
  border: `1px solid ${theme.palette.divider}`,
  flexDirection: "initial",
  alignItems: "stretch",
}));

export const DataStack = styled(Stack)(({ theme: _theme }) => ({
  alignItems: "stretch",
  flex: "1 1 auto",
}));

export const VisibleData = styled(Stack)(({ theme: _theme }) => ({
  padding: "24px",
  alignItems: "stretch",
  gap: "24px",
  alignSelf: "stretch",
}));

export const AccordionDetailsVisibleData = styled(Stack)(({ theme: _theme }) => ({
  alignItems: "stretch",
  gap: "24px",
  alignSelf: "stretch",
}));

export const DetailsRow = styled(Stack)(({ theme: _theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "24px",
}));

export const MyStyledAccordion = styled(Accordion)(({ theme: _theme }) => ({
  "&:last-of-type:not(.MuiCard-root)::after": {
    display: "none",
  },
}));

export const QuoteDetailsdHeader = styled(Stack)({
  flexDirection: "row",
  justifyContent: "space-between",
});

export const QuoteDetailsVisibleData = styled(Stack)(({ theme: _theme }) => ({
  padding: "16px",
  alignItems: "stretch",
  alignSelf: "stretch",
  gap: "24px",
}));

export const AlternativeLineHeader = styled(Stack)(({ theme }) => ({
  padding: "0 16px",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  backgroundColor: theme.palette.surfaceContainer.low,
}));

export const ContainerStack = styled(Stack)(({ theme: _theme }) => ({
  borderRadius: "8px",
  gap: "2px",
  overflow: "hidden",
}));
